export default ({ request }) => ({
  tcFabricSalesListApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/list',
      method: 'post',
      data,
    })
  },
  tcFabricSalesDetailApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/detail',
      method: 'post',
      data,
    })
  },
  tcFabricSalesCreateDataApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/createData',
      method: 'post',
      data,
    })
  },
  tcFabricSalesSaveApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/save',
      method: 'post',
      data,
    })
  },
  tcFabricSalesDelApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/del',
      method: 'post',
      data,
    })
  },
  tcFabricSalesReviewApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/review',
      method: 'post',
      data,
    })
  },
  tcFabricSalesExportCheckApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/sales/exportCheck',
      method: 'post',
      data,
    })
  },
})
